import { __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

/**
 * Schema for resource summary data displayed on index/listing pages.
 * This is the summarized representation of a resource shown in cards,
 * as opposed to the full resource details shown on individual pages.
 */
export const ResourceSummarySchema = /* @__PURE__ */ (() => {
var __zs=z.object({
  heading: z.string().optional(),
  image: safeOptional(
    z
      .object({
        description: z.string().optional().nullable(),
        url: z.string().optional().nullable(),
      })
      .nullable(),
  ),
  path: z.string().optional(),
  description: safeOptional(RichTextSchema.nullable()),
});
var __rf=[__zs.shape["image"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs.shape["description"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_1={};
var __rfn_5=__rf[0];
var __rfn_10=__rf[1];
function __vb_13(input){var __bv_2,__bv_3,__bx_4,__bw_6,__bv_7,__bv_8,__bx_9,__bw_11,__bo_12;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_1;__bv_2=input["heading"];if(!((__bv_2===undefined||(typeof __bv_2==="string"))))return __bf_1;__bv_3=input["image"];if(__bv_3===undefined){__bw_6=undefined;}else{__bx_4=__rfn_5(__bv_3);__bw_6=__bx_4;}__bv_7=input["path"];if(!((__bv_7===undefined||(typeof __bv_7==="string"))))return __bf_1;__bv_8=input["description"];if(__bv_8===undefined){__bw_11=undefined;}else{__bx_9=__rfn_10(__bv_8);__bw_11=__bx_9;}__bo_12={};if(__bv_2!==undefined||("heading" in input)){__bo_12["heading"]=__bv_2;}if(__bw_6!==undefined||("image" in input)){__bo_12["image"]=__bw_6;}if(__bv_7!==undefined||("path" in input)){__bo_12["path"]=__bv_7;}if(__bw_11!==undefined||("description" in input)){__bo_12["description"]=__bw_11;}return __bo_12;}
var __rfm_z=__zs.safeParse;
function safeParse_ResourceSummarySchema(input){
var __bd_14=__vb_13(input);
if(__bd_14!==__bf_1){return{success:true,data:__bd_14};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_ResourceSummarySchema,__zs,null,null);
})()

export type ResourceSummary = z.infer<typeof ResourceSummarySchema>
